import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, Subject, BehaviorSubject, Subscription, of } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { CommerrorService } from './commerror.service';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { finalize, shareReplay, take } from 'rxjs/operators';

const LANG_MAP: Record<string,string> = {
  English: 'en-US',
  Hebrew:  'he-IL',
  Polish:  'pl-PL',
  Spanish: 'es-ES',
  Italian: 'it-IT',
  Arabic:  'ar-JO'
  };

// The API's answer when a 2FA code could not be sent (aweb-api-Appointments utils/twofa.js).
interface TwoFaSendFailure {
  status: 'fail';
  twofaSendFailed: true;
  attemptedMethod: 'sms' | 'whatsapp';
  alternateMethod: 'sms' | 'whatsapp';
  error: string;
}
interface ClinicData {
  status: string;
  hasLeumitCode: boolean;
  // Add any other properties you expect to receive from the server
}
@Injectable({
  providedIn: 'root'
})
export class LoginService {
  contLogin = false;
  username: string;
  limits;
  public premissions = null;
  totpVerify =false;
  public invasiveExams = false;
  UID;
  ClinicEmployeeNum: number;
  linksent;
  concentCount;
  base64;
  clinicUsers;
  rooms
  userBilling;
  public loggedIn = false;
  loginError: string;
  getCode = false;
  lastAwl:string;
  lastAwlExam:string;
  lastAwlStartDate:any;
  lastAwlEnDate:any;
  export$ = new Subject<any>()
  exportLoading = false;
  ENVLoaded = new Subject<void>();
  public clinicalAccess: boolean = true;
  public category = {
    name: "doctor",
    canOpen: {
      form:true,
      exam:true
    },
    canCreate:{
      form:true,
      exam:true
    },
    canChange:{
      form:true,
      exam:true
    },
    canSend: {
      form:true,
      exam:true
    },
    todayList: true
  };
  public hastech = false;
  public Recording: string;
  public RemoteRTC = false;
  public hasAWL = false;
  public AWLUnlimited = false;
  public bitRate = 500000;
  public highBit = 3000000;
  public AWLOnlyExams = false;
  public onLogin: Subject<void>;
  public onFailedLogin: Subject<void>
  public onLoginComplete: Subject<void>
  // Fired once on entering the main Appointments screen — this repo has no
  // exam concept, so it's the "exam" trigger equivalent for popup bubbles.
  public mainScreenLoaded$: Subject<void> = new Subject<void>();
  // Fired with the tab key whenever the appointments screen switches tabs
  // (Calendar/Patients/List/Appointments Stats) — consumed by
  // AnnouncementHostComponent for trigger:'tab' bubbles.
  public tabChanged$: Subject<string> = new Subject<string>();
  public canOpenExams: boolean;
  public fullDelivery: string = 'download';
  public printLang: string = null;
  public printStyle: string = null;
  public userType = 'doctor';
  public summaryOnlyAnamolies = false;
  archiveServer: string;
  loginname:string;
  public printAllMeas = true
  public dopplerAutoOk = true;
  public RequireLoginToOpen = false;
  public anatomyAltNames;
  public hasChameleon = true;
  public hasFollicles=true;
  public defaultsButton = false;
  public links = true;
  public Clinic: string;
  public ClinicID:number;
  public localServer = false;
  public letterhead=false;
  location: string;
  public VideoCodec = 'video/webm;codecs=vp9';
  public clinicOptions;
  public filteredClinicSearch: [] = [];
  public isArtisanSupport = false;
  public usersList: any[] = [];
  public filteredUserSearch: any[] = [];  
  public ishospital: any = false;
  public isSheba: any = false;
  public doubleOrgans:string
  public hasLeumit = false;
  public isCardio=false;
  public isGastro=false;
  public isEyes=false
  public isUSG=false
  public isObgyn=false
  public PRNcheck = true;
  public requireExamLogon = true;
  public AWLExamNames = false;
  public hasEmergencyRoom = false;
  public altArchiveName:string = null;
  public CustomHeader = new UntypedFormControl(false)
  picAlt="Header Pic"
  headerToShow;
  isImageLoading = false;
  public altSplashPage;
  public isAdmin= false;
  public noneAsMeasDefault = false;
  public LeumitAdmin = false;
  public barcodeScan = false;
  public ExamCodes;
  public hasENV = false;
  public doctor = null;
  public room=null
  public PeerServ: {host: string, port: number, path: string};
  public separatedClinic = false;
  public SeparateZimun = false;
  public defaultExams;
  public hasSurrogatePreg = false;
  public lmp_in_mwl = false;
  public hasImaging = false;
  public APIversion:string;
  public usMode=false
  private sessionExpiration = new BehaviorSubject<string>('');
  private sessionExpirationSubscription: Subscription;
  private timeoutId: any;
  appointmentsByPatient=false
  public officeServer = false;
  //public isLoading: boolean = false; OLD LOADER
  private cachedCredentials: { user: string, pw: string,location?: string } | null = null;
  // 2FA send-failure UX: the channel to offer next (null once every channel has been tried,
  // and the message points at support instead of a button).
  twoFaAlternateMethod: 'sms' | 'whatsapp' | null = null;
  private triedTwoFaMethods = new Set<string>();
  public showTwoFactorInput = false;
  public twoFactorRequired = new Subject<void>();
  public updateInfoRequired = new Subject<void>();
  public isLoginLoading: boolean = false;
  public isLoading: boolean = false;
  // True when this session started via a one-time redirectCodes login (i.e. the
  // user arrived from a clinical system), as opposed to a direct username/password
  // login on awebAppointments itself. Drives the "back to clinical system" button.
  public enteredViaCode: boolean = false;

  constructor(
    private http: HttpClient,
    private router: Router,
    private sanitization: DomSanitizer,
    private commerrorService: CommerrorService,
    private translate: TranslateService,
    private titleService: Title
  ) {
      this.onLogin= new Subject();
      this.onFailedLogin = new Subject();
      this.onLoginComplete = new Subject();
      this.http.get('/api/getenv').subscribe((data)=>{
        let p = {};
        p['env'] = data;
        this.setEnv(p);
      },(error)=> { 
        console.log(error);
      })

      // this.sessionExpirationSubscription = this.sessionExpiration.asObservable().subscribe(expiration => {
      //   this.handleSessionExpiration(expiration);
      // });
   }

  //  ngOnDestroy() {
  //   if (this.sessionExpirationSubscription) {
  //     this.sessionExpirationSubscription.unsubscribe();
  //   }
  //   clearTimeout(this.timeoutId);
  // }

  async login(
    user: string,
    pw: string,
    navigate = true,
    exam = false,
    isexport = false,
    code = undefined
  ) {
    try {
      this.isLoginLoading = true;

      const whereamiData = await this.checkConnector();
      const shouldSkipConnector = await this.shouldSkipConnector(user);

      if (whereamiData && !shouldSkipConnector) {
        this.localServer = true;

        if (whereamiData.office_server) {
          this.officeServer = true;
          this.ldapLogin(user, pw, whereamiData, navigate);
          return true;
        } else if (whereamiData.location) {
          const req = this.http.post("/api/login", {
            user,
            pw,
            inside: exam,
            location: whereamiData.location,
            code,
          });
          this.cachedCredentials = { user, pw, location: whereamiData.location };
          this.resetTwoFaFallback();
          req.pipe(finalize(()=> {
            this.isLoginLoading = false;
          })).subscribe({
           next: (response:any) => {
            if(response && response.state === 'require_2fa') {
                this.twoFactorRequired.next();
             } else if(response && response.state === 'requireUpdateInfo') {
                this.updateInfoRequired.next();
             } else {
                this.followLogin(of(response), navigate, user);
             }
            },
            error: (err) => {
               this.loginError = err.error?.error || "An unexpected error occurred.";
            }                  
          })
          //this.followLogin(req, navigate, user);
        }
      } else {
        this.localServer = false;

        if (!exam) {
          const req = this.http.post("/api/login", { user, pw, inside: exam, code });
          this.cachedCredentials = { user, pw };
          this.resetTwoFaFallback();
          req.pipe(finalize(()=> {
            this.isLoginLoading = false;
          })).subscribe({
           next: (response:any) => {
            if(response && response.state === 'require_2fa') {
                this.twoFactorRequired.next();
             } else if(response && response.state === 'requireUpdateInfo') {
                this.updateInfoRequired.next();
             } else {
                this.followLogin(of(response), navigate, user);
             }
            },
            error: (err) => {
               this.loginError = err.error?.error || "An unexpected error occurred.";
            }                  
          })          
          //this.followLogin(req, navigate, user);
        }
      }
    } catch (error) {
      this.isLoginLoading = false;
      console.error("Unexpected error during login:", error);
    }
  }

  checkConnector(): Promise<any> {
    return new Promise((resolve) => {
      this.http.get("http://localhost:8088/alive").subscribe({
        next: (aliveData: any) => {
          if (aliveData && aliveData.status === "alive") {
            this.http.get("http://localhost:8088/whereami").subscribe({
              next: (whereamiData: any) => resolve(whereamiData),
              error: () => resolve(false),
            });
          } else {
            resolve(false);
          }
        },
        error: () => resolve(false),
      });
    });
  }

  shouldSkipConnector(username): Promise<any> {
    return new Promise((resolve) => {
      this.http.get(`/api/skipconnector/${username}`).subscribe({
        next: (data: any) => {
          if (data && data.shouldSkip) {
            resolve(true)
          } else {
            resolve(false);
          }
        },
        error: () => resolve(false),
      });
    });
  }

  followLogin(req, navigate = true,user=null, isexport = false){
    this.clinicOptions = null;
    req.subscribe((data)=>{
      // A {status:'fail'} answer (e.g. the 2FA code could not be sent) carries no env, and
      // setEnv() below dereferences data.env first - it threw and aborted this callback before
      // the error was ever shown. Surface the error and stop here.
      if (data && data['status'] == 'fail') {
        if (data['twofaSendFailed']) this.handle2FASendFailure(data);
        else this.loginError = data['error'] || 'Login failed';
        this.contLogin = false;
        this.isLoginLoading = false;
        this.onFailedLogin.next();
        return;
      }
      if(data.hasOwnProperty("status") && data["status"] == "ok" && ! data.hasOwnProperty('code')){
        if(isexport){
          this.export$.next(this.exportData())
          return;
        }
        this.Clinic = null;
        if(data['Clinic']){
          this.Clinic = data['Clinic'];
          const clinicName = this.Clinic; 
          this.titleService.setTitle(`${clinicName} - Aweb Administration`);
         
          
        }
        this.isArtisanSupport = !!data['isArtisanSupport'];    
        this.loginError = null;
        this.loginname = user;
        this.UID = data['uid'];
        this.username=data["uname"];
        this.ClinicEmployeeNum = data['ClinicEmployeeNum'];
        this.LeumitAdmin = data['HMO'];
        this.totpVerify = data['TOTPSet'];
        this.appointmentsByPatient=data['appointmentsByPatient']? true:false
        this.separatedClinic = false;
        if(data['hasSeparation'])
          this.separatedClinic = true;
        if(data['SeparateZimun'])
          this.SeparateZimun = true;
        else
          this.SeparateZimun=false;
        this.hasSurrogatePreg = data['hasSurrogatePreg'];
        this.lmp_in_mwl = false;
        if(data['lmp_in_mwl'])
          this.lmp_in_mwl = true;
        
        if(data["category"]){
          switch (data["category"]) {
            case "forms":
              this.category={
                name: data["category"],
                canOpen: {
                  form:true,
                  exam:false
                },
                canCreate:{
                  form:true,
                  exam:false
                },
                canChange:{
                  form:true,
                  exam:false
                },
                canSend: {
                  form:true,
                  exam:false
                },
                todayList: true
              }
              break;
              case "tech":
                this.category={
                  name: data["category"],
                  canOpen: {
                    form:true,
                    exam:true
                  },
                  canCreate:{
                    form:true,
                    exam:true
                  },
                  canChange:{
                    form:true,
                    exam:true
                  },
                  canSend: {
                    form:true,
                    exam:true
                  },
                  todayList: true
                }
                break;
            case "secretary":
              this.category = {
                name: data["category"],
                canOpen: {
                  form:false,
                  exam:false
                },
                canCreate:{
                  form:false,
                  exam:false
                },
                canChange:{
                  form:false,
                  exam:false
                },
                canSend: {
                  form:false,
                  exam:true
                },
                todayList: true
              }
              break;
            case "nurse":
              this.category = {
                name: data["category"],
                canOpen: {
                  form:true,
                  exam:true
                },
                canCreate:{
                  form:true,
                  exam:false
                },
                canChange:{
                  form:true,
                  exam:false
                },
                canSend: {
                  form:true,
                  exam:true
                },
                todayList: true
              }
              break;
            case "doctor":
              this.category = {
                name: data["category"],
                canOpen: {
                  form:true,
                  exam:true
                },
                canCreate:{
                  form:true,
                  exam:true
                },
                canChange:{
                  form:true,
                  exam:true
                },
                canSend: {
                  form:true,
                  exam:true
                },
                todayList: true
              }
              break;        
            default:
              this.category = {
                name: data["category"],
                canOpen: {
                  form:true,
                  exam:true
                },
                canCreate:{
                  form:true,
                  exam:true
                },
                canChange:{
                  form:true,
                  exam:true
                },
                canSend: {
                  form:true,
                  exam:true
                },
                todayList: true
              }
              break;
          }
        }
        if(! this.ishospital)
          this.getLimits();
        // clinicalAccess: null/undefined = full access (backward compat); false = appointments only
        this.clinicalAccess = data['clinicalAccess'] != false;
        if(data["membership"])
          this.userType = data["membership"];  
        else{//no login
          if(data['env']['requiregroup']){
            this.loginError = "User is not authorized to use this system";
            return;
          }
          this.userType = 'doctor';//otherwise assume doctor
        }
        // this.isAdmin = data['isAdmin'];
        this.isAdmin = data['isAdmin'] || this.userType=='admin';
        this.clinicUsers = data['users'];
        this.rooms=data['rooms']
        this.userBilling = data['userBilling'];
        if(this.userType == 'doctor')
          this.doctor = this.UID;
        this.canOpenExams = data["openExams"];
        if(data['clinics']){
          this.clinicOptions = data['clinics'];
          this.filteredClinicSearch = this.clinicOptions; // add the fliteredOne
        }
        else{
          this.onLogin.next();
          if(navigate){
            this.router.navigate(['/main']); 
          }
        } 
      }
      if(data.hasOwnProperty('letterhead'))
        this.letterhead = data['letterhead'];
      else
        this.letterhead = false;
    this.requireExamLogon = data['requireExamLogon'];
    this.setEnv(data);
    if(data['GID'] && ! this.ishospital){
      this.ClinicID = data['GID'];
        this.http.get(`/api/login/getTOS`).subscribe((data) => {
          this.isLoading = false;
          this.premissions = data[0];
          this.setInterfaceLanguage(this.premissions?.interfaceLanguages)
          this.onLoginComplete.next();
        })   
    }
      if(data.hasOwnProperty('code')){
        this.getCode=true;
      }
      if(data.hasOwnProperty("error")){
        this.loginError = data["error"]
        this.isLoading = false;
      }
      this.contLogin = false;
      this.isLoginLoading = false;
    },(error)=>{
      this.isLoading = false;
      this.isLoginLoading = false;
      this.loginError = error.error?.error || 'Login request failed.';
      console.error("Error in followLogin:", error);
      this.onFailedLogin.next();
    });
    return req
  }

  setEnv(data){
    this.ishospital = data['env']['ishospital'];
    if(data["env"]){
      if( data["env"]["recording"]){
        this.Recording = data["env"]["recording"];
        if(data["env"]["webrtc"] == "remote"){
          this.RemoteRTC = true;
          this.PeerServ = data["env"]["peerServer"];
        }
      }
      if(this.ishospital ){
        this.premissions = data["env"]["premissions"]
        this.invasiveExams = this.premissions.ObstetricInvasive;
        this.defaultExams = null;
        if(data.defaultExams)
          this.defaultExams = data.defaultExams;
          if(data['env']['usMode']){
            this.usMode = data['env']['usMode'];
          }  
      }
      if(data['env']['isSheba']){
        this.isSheba = data['env']['isSheba']
      } if(data['env']['doubleOrgans']){
        this.doubleOrgans = data['env']['doubleOrgans']
      }
      if(data['env']['hasTech'])
        this.hastech = data['env']['hasTech'];
      if(data['env']['bitRate'])
        this.bitRate = data['env']['bitRate'];
      if(data['env']['highBitrate'])
        this.highBit = data['env']['highBitrate'];
      if(data["env"]["AWL"])
        this.hasAWL = true;
      if(data["env"].hasOwnProperty("AWLOnlyExamOpening"))
        this.AWLOnlyExams = data["env"]['AWLOnlyExamOpening'];
      if(data["env"]["printLang"])
        this.printLang = data["env"]["printLang"];
      if(data["env"]["printStyle"])
        this.printStyle = data["env"]["printStyle"];
      if(this.ishospital)
        this.RequireLoginToOpen = true;
      else{
        if(data["env"]["RequireLoginToOpen"])
          this.RequireLoginToOpen = data["env"]["RequireLoginToOpen"];
      }
      if(data["env"]["FullDelivery"])
        this.fullDelivery = data["env"]["FullDelivery"];
      if(data["env"]["AWLUnlimitedExams"])
        this.AWLUnlimited = data["env"]["AWLUnlimitedExams"];
      if(data["env"].hasOwnProperty('dopplerAutoOK'))
        this.dopplerAutoOk = data["env"]["dopplerAutoOK"];
      if(data["env"].hasOwnProperty("hasChameleon"))
        this.hasChameleon = data["env"]["hasChameleon"];
      if(data['env'].hasOwnProperty('hasFollicles'))
        this.hasFollicles = data['env']['hasFollicles'];
      if(data['env']['videoCodec'])
        this.VideoCodec = data['env']['videoCodec'];
      if(data['env']['archiveserv'])
        this.archiveServer = data['env']['archiveserv'];
      if(data['env']['anomaliesInSummary'])
        this.summaryOnlyAnamolies = data['env']['anomaliesInSummary'];
      if(data['env']['altNames'])
        this.anatomyAltNames = data['env']['altNames'];
      if(data['env']['defaultsButton'])
        this.defaultsButton = data['env']['defaultsButton'];
      if(data['env'].hasOwnProperty('smslink'))
        this.links = data['env']['smslink'];
      if(data['env'].hasOwnProperty('noprncheck'))
        this.PRNcheck = ! data['env'].noprncheck;
      if(data['env']['altSplash'])
        this.altSplashPage = data['env']['altSplash'];
      if(data['env']['hasEmergencyRoom'])
        this.hasEmergencyRoom = true;
      if(data['env']['awlExamNames'])
        this.AWLExamNames = data['env']['awlExamNames'];
      if(data['env']['altArchiveName'])
        this.altArchiveName = data['env']['altArchiveName'];
      if(data['env'].hasOwnProperty('measDefaultNone'))
        this.noneAsMeasDefault = data['env']['measDefaultNone'];
      if(data['env']['barcodeScan'])
        this.barcodeScan = data['env']['barcodeScan'];
      if(data['env']['examCodes'])
        this.ExamCodes = data['env']['examCodes'];
      if(data['env']['version'])
        this.APIversion = data['env']['version'];
    }
    if(data.hasOwnProperty('hasLeumit'))
      this.hasLeumit = data.hasLeumit;
      this.isCardio = data.isCardio ;
      this.isGastro=data.isGastro;
      this.isEyes=data.isEyes;
      this.isUSG=data.isUSG;
      this.isObgyn=(this.isCardio || this.isEyes || this.isGastro || this.isUSG) ? false: true
    if(this.isCardio && this.userType){
        switch(this.userType){
          case 'doctor':
            this.lastAwl = 'Completed';
          break;
          case 'tech':
            this.lastAwl = 'Received';
          break;
          case 'secretary':
            this.lastAwl = 'Waiting';
          break;
        }
    }
    if(data['hasImaging'])
      this.hasImaging = data['hasImaging'];
    this.ENVLoaded.next();
    this.hasENV = true;
  }


  // getSessionExpiration() {
  //   return this.sessionExpiration.asObservable();
  // }

  // updateSessionExpiration(newExpiration: string) {
  //   this.sessionExpiration.next(newExpiration);
  // }

  // private handleSessionExpiration(expiration: string) {
  //   const expirationTime = new Date(expiration).getTime();
  //   const currentTime = Date.now();
  //   const timeLeft = expirationTime - currentTime;

  //   // Clear previous timeout if any
  //   clearTimeout(this.timeoutId);

  //   if (timeLeft > 10000) { // more than 10 seconds left
  //     this.timeoutId = setTimeout(() => {
  //       this.commerrorService.errorSession('Session About To Expire', 'Your session will expire soon')
  //       console.log('Your session is about to expire.');
  //     }, timeLeft - 10000); // Set timeout to trigger 10 seconds before expiration
  //   }
  // }


  sendCode(code: string){
    let req = this.http.get("api/logincode",{params:{"code": code}});
    req.subscribe((data)=>{
      if(data.hasOwnProperty("status") && data["status"] == "ok"){
        this.loginError = null;
        this.username=data["uname"];
        this.getCode=false;
        this.router.navigate(['/main']);   
      }
      if(data.hasOwnProperty("error")){
        this.loginError = data["error"]
      }
    },(error)=>{
      this.loginError = error.error.error;
    });
  }

  public getUserName(){
    return this.username
  }

  loginAsCurrentUser(){
    if(this.username && ! this.requireExamLogon)
      this.onLogin.next();
  }

ldapLogin(user: string, pw: string, serv, navigate = false) {
    this.http.post('http://localhost:8088/login', { login: user, 'pw': pw }).subscribe((data: any) => {
      if (data.hasOwnProperty("error")) {
        this.isLoginLoading = false;
        this.loginError = data["error"];
      } else {
        if (serv['location'])
          data['location'] = serv['location'];
        
        this.cachedCredentials = { user, pw, location: serv['location'] };
        
        const remoteReq = this.http.post('/remote/login', data);
        
        this.followLogin(remoteReq, navigate, user);
      }
    }, (err) => {
      this.isLoginLoading = false;
      console.log(err);
      this.loginError = err.error.error;
    })
  }

  public getArchiveServer():string{
    return this.archiveServer;
  }

  public async Logout() {
    // The typed password was kept for the 2FA verify / resend; it must not outlive the session.
    this.cachedCredentials = null;
    this.resetTwoFaFallback();
    (await this.clearCookies()).subscribe((data) => {
      this.router.navigate([""]);
      this.export$.next(false);
      this.totpVerify = false;
      this.doctor=null
      this.room=null
      this.Clinic = null;
      this.titleService.setTitle(`Aweb Administration`);
     
    })
  }

  public canStartExam(hasawl: boolean):boolean{
    return this.canOpenExams && (this.ishospital || this.localServer) && (this.userType == 'doctor' || this.userType== 'tech') &&(! this.AWLOnlyExams ||  (this.AWLOnlyExams && hasawl));
  }

  public loginMissing(){
    if(! this.username)
      this.router.navigate(['/']);
  }

  public showAWL():boolean{
    return this.hasAWL && (! this.ishospital || this.userType == 'doctor' || this.userType == 'tech' || this.userType == 'secretary');
  }

  // setClinic(id:number){
  //   this.http.get('/api/setclinic/'+ this.clinicOptions[id].GID).subscribe((data:ClinicData)=>{
  //     this.ClinicID = this.clinicOptions[id].GID;
  //     this.Clinic = this.clinicOptions[id].ClinicTitle;
  //     const clinicName = this.Clinic; 
  //     this.titleService.setTitle(`Aweb Administration - ${clinicName}`);
  //     this.hasLeumit = data.hasLeumitCode;
  //     if(this.clinicOptions[id].MarginTop || this.clinicOptions[id].MarginBottom)
  //       this.letterhead = true;
  //     this.clinicOptions = null;
  //     this.loginError = null;
  //     this.http.get(`/api/login/getTOS`).subscribe((data) => {
  //       this.premissions = data[0];
  //     })
  //     this.onLogin.next();
  //     this.router.navigate(['/main']);   
  //   },(error)=>{
  //     this.loginError = error;
  //     this.onFailedLogin.next();
  //   })
  // }
  setClinic(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      
      const selectedGid = this.clinicOptions[id].GID;
      
      this.http.get('/api/setclinic/' + selectedGid).subscribe({
        next: (data: any) => {
          this.ClinicID = selectedGid;
          this.Clinic = this.clinicOptions[id].ClinicTitle;
          this.hasLeumit = data.hasLeumitCode;
          const clinicName = this.Clinic; 
          this.titleService.setTitle(`Aweb Administration - ${clinicName}`);
          this.hasLeumit = data.hasLeumitCode;
          if(this.clinicOptions[id].MarginTop || this.clinicOptions[id].MarginBottom)
          this.letterhead = true;

          this.http.get(`/api/login/getTOS`).subscribe((tosData) => {
             this.premissions = tosData[0];
             if (this.isArtisanSupport) {
                this.getClinicUsers(selectedGid).subscribe({
                    next: (users) => {
                        this.usersList = users;
                        this.filteredUserSearch = users;
                        resolve(false);
                    },
                    error: (err) => {
                        this.loginError = "Failed to load clinic users";
                        reject(err);
                    }
                });
             } else {
                 this.clinicOptions = null;
                 this.onLogin.next();
                 this.router.navigate(['/patsearch']);
                 resolve(true);
             }
          });
        },
        error: (err) => {
          this.loginError = err;
          this.onFailedLogin.next();
          reject(err);
        }
      });
    });
  }
  getClinicUsers(gid: number) {
    return this.http.get<any[]>(`/api/admin/clinicUsers/${gid}`);
  }
  
  impersonateUser(uid: number) {
  this.isLoginLoading = true;
  this.http.post('/api/login/impersonate', { uid: uid }).subscribe({
    next: (res: any) => {
      
      // followLogin's third argument becomes `loginname` - the name typed at a login prompt,
      // not the display name. The API sends both; `uname` is the fallback for an older API.
      this.followLogin(of(res), true, res.loginName || res.uname,false);
    },
    error: (err) => {
      this.isLoginLoading = false;
      this.loginError = err.error?.error || "Impersonation failed";
    }
  });
 }
  getUserType(){
    return this.userType;
  }

  saveHeader(formData){
    this.http.post(`/api/NewExams/setHeader/${this.CustomHeader.value ? 'y' : 'n'}`,formData).subscribe((data) => {
      console.log(data);
    })
  }

  getHeader(){
    this.http.get('/api/NewExams/getHeader' ).subscribe((data)=>{
      if(data['CustomLogo']){
        this.CustomHeader.patchValue(data['CustomLogo'])
      }
      if((data['PrintHeader'] || data['PrintHeaderCustom'] ) && ! this.ishospital && ! this.isCardio)
        this.getImageFromService();
    })
  }
  chaneHeader(){
    this.http.post('/api/NewExams/chageHeaderSetting', {CustomLogo: this.CustomHeader.value}).subscribe()
  }

  getImage(): Observable<Blob> {
    if(this.ishospital){
      if(this.CustomHeader.value){
        this.headerToShow = `../../assets/images/${this.getUserName()}.jpg`
      }else{
        this.headerToShow = `../../assets/images/clinic.jpg`
      }
      
    }else{
      if(this.CustomHeader.value){
        return this.http.get(`/api/NewExams/getImage/y`, { responseType: 'blob' });
      }else{
        return this.http.get(`/api/NewExams/getImage/n`, { responseType: 'blob' });
      }
    }
  }
  createImageFromBlob(image: Blob) {
    // this.headerToShow = this.sanitization.bypassSecurityTrustUrl(URL.createObjectURL(image))
    let reader = new FileReader();
    reader.addEventListener("load", () => {
       this.base64 = reader.result;
      // this.headerToShow = reader.result;
      this.headerToShow = this.sanitization.bypassSecurityTrustUrl(this.base64)

    }, false);
 
    if (image) {
       reader.readAsDataURL(image);
    }
 }
 getImageFromService() {
  this.isImageLoading = true;
  if(this.ishospital){
    if(this.CustomHeader.value){
      this.headerToShow = `../../assets/images/${this.getUserName()}.jpg`
    }else{
      this.headerToShow = `../../assets/images/clinic.jpg`
    }
  }
}

  exportData(){
    this.exportLoading = true;
    return this.http.get('/api/stats/exportdata')
  }

  getDocByUID(uid:number){
    for(let usr of this.clinicUsers){
      if(usr.UID == uid)
        return usr.Name;
    }
    return '';
  }

  getRoomByRID(RID:number){
    for(let room of this.rooms){
      if(room.AutoIndex == RID)
        return room.RoomName;
    }
    return '';
  }

  // Whether a one-time room's pinned date is already in the past
  isExpiredOneTime(room:any): boolean {
    if(!room || !room.isOneTime || !room.oneTimeDate) return false;
    const last = new Date(room.oneTimeDateTo || room.oneTimeDate); last.setHours(0,0,0,0);
    const today = new Date(); today.setHours(0,0,0,0);
    return last < today;
  }

  get activeRooms(): any[] {
    return (this.rooms || []).filter(r => !this.isExpiredOneTime(r));
  }

  roomLabel(room:any): string {
    if(!room) return '';
    if(!room.isOneTime) return room.RoomName;
    return room.RoomName + ' (חד פעמי)';
  }

  getLimits(){
    this.http.get('/api/limits').subscribe((data) =>{
      this.limits = data;
    })
  }

  countLinks(){
    this.http.get('/api/NewExams/countLinks').subscribe((data:any) =>{
      this.linksent = data;
    })
  }

  
  countConcent(){
    this.http.get('/api/NewExams/countConcent').subscribe((data:any) =>{
      this.concentCount = data;
    })
  }

  async clearCookies() {
    return this.http.get("/api/login/clearCookies");
  }

  public setInterfaceLanguage(language: string): Observable<any> {
    const locale = LANG_MAP[language] || "en-US";
    return this.translate.use(locale);
  }
  sendPasswordResetCode(username: string): Observable<any> {
    return this.http.post('/api/login/sendResetCode', { user: username });
  }  

  resetPassword(username: string, code: string, newPassword: string): Observable<any> {
    return this.http.post('/api/login/resetUserPW', { 
      user: username, 
      newPW: newPassword, 
      code: code 
    });
  }
  
   async completeLoginWith2FA(code: string, navigate = true) {
    if (!this.cachedCredentials) {
      // falls incase no login body params detected
      this.loginError = "Please enter your username and password again.";
      return;
    }

    // Replay `location` (lesson 32): every call that continues an in-flight login must look like
    // the request that started it. Without it the server resolves the user through a different
    // query shape - clinic Connector instead of the room - and can land on the wrong role,
    // location and Leumit flag.
    const { user, pw, location } = this.cachedCredentials;

    const req = this.http.post("/api/login", { "user": user, "pw": pw, "twofacode": code, location });

    req.subscribe({
        next: (data:any) => {
          if(data && data.error) {
            this.loginError = data.error;
            this.showTwoFactorInput = false;
          } else {
             this.followLogin(of(data), navigate, user);
          }
        },
        error: (err) => {
        // err.error is the parsed response BODY ({error, status} on a 401), not a string -
        // assigning it whole rendered "[object Object]" exactly when the user needs the reason.
        this.loginError =
          err?.error?.error ||
          (typeof err?.error === 'string' ? err.error : null) ||
          "An unexpected error occurred.";
      }
    })
  }

  // A code could not be sent. Say which channel failed and offer the other one if it has not
  // been tried; once both are exhausted twoFaAlternateMethod is null and the message points at
  // support. (aweb 9c2238fe)
  private handle2FASendFailure(data: TwoFaSendFailure) {
    const attempted = data['attemptedMethod'];
    const alternate = data['alternateMethod'];
    if (attempted) this.triedTwoFaMethods.add(attempted);
    const canTryAlternate = alternate && !this.triedTwoFaMethods.has(alternate);
    this.twoFaAlternateMethod = canTryAlternate ? alternate : null;
    this.loginError = this.compose2FASendError(attempted, this.twoFaAlternateMethod);
  }

  private compose2FASendError(attempted: string, alternate: string | null): string {
    const label = (m: string) => (m === 'sms' ? 'SMS' : 'WhatsApp');
    if (alternate)
      return (
        `We couldn't send your verification code by ${label(attempted)}. ` +
        `You can try ${label(alternate)} instead - or contact support if the problem continues.`
      );
    return "We couldn't reach you by SMS or WhatsApp. Please contact support so we can get you signed in.";
  }

  private resetTwoFaFallback() {
    this.twoFaAlternateMethod = null;
    this.triedTwoFaMethods.clear();
  }

  // Re-send over the chosen channel. Success opens the 2FA panel; another failure re-runs the
  // handler, which then points at support instead of offering a button.
  retry2FAWith(method: 'sms' | 'whatsapp') {
    if (!this.cachedCredentials) {
      this.loginError = 'Please enter your username and password again.';
      return;
    }
    this.isLoginLoading = true;
    this.twoFaAlternateMethod = null; // hide the button while the attempt is in flight
    this.requestResend2FACode(method).subscribe({
      next: (res: any) => {
        this.isLoginLoading = false;
        if (res?.state === 'require_2fa') {
          this.loginError = null;
          this.twoFactorRequired.next();
        } else if (res?.status === 'fail' && res?.twofaSendFailed) {
          this.handle2FASendFailure(res as TwoFaSendFailure);
        } else if (res?.error) {
          this.loginError = res.error;
        }
      },
      error: (err) => {
        this.isLoginLoading = false;
        this.loginError = err?.error?.error || "We couldn't send the code. Please contact support.";
      },
    });
  }

  // Re-authentication inside an already-signed-in session (the docpanel export login box).
  // /api/login/examlogin skips 2FA because the session already passed it - the box has no 2FA
  // panel, so going through /api/login hung on require_2fa (lesson 12). isexport reaches
  // followLogin, which hands the export to the docpanel; login() used to drop it.
  examLogin(user: string, pw: string, isexport = false) {
    this.isLoginLoading = true;
    const location = this.cachedCredentials?.location;
    const req = this.http.post('/api/login/examlogin', { user, pw, location }).pipe(
      finalize(() => (this.isLoginLoading = false)),
      shareReplay(1)
    );
    // followLogin owns success and {status:'fail'}; a non-2xx (wrong password, 401) lands in its
    // error handler, which sets loginError and emits onFailedLogin to restore the box's button.
    this.followLogin(req, false, user, isexport);
  }

  requestResend2FACode(method: 'whatsapp' | 'sms'): Observable<any> {
    const { user ,pw ,location } = this.cachedCredentials;
    return this.http.post('/api/login', { 
      user: user, 
      pw: pw, 
      resend2FA: true,
      location,
      '2faMethod': method // method type (whatsapp or sms)
    });
  }

// we are going to call this login route when using Code
public async loginWithCode(code: string): Promise<boolean> {
  this.isLoginLoading = true;
  try {
    const loginRequest$ = this.http.post("/api/login", { code }).pipe(
      shareReplay(1)
    );

    this.followLogin(loginRequest$, false); 

    const data: any = await loginRequest$.toPromise(); 

    if (data && data.status === 'ok' && data.GID && !this.ishospital) {
       await this.onLoginComplete.pipe(take(1)).toPromise();
    }

    if (data && data.status === 'ok') {
      this.enteredViaCode = true;
      return true;
    }

    return false;

  } catch (error) {
    this.isLoginLoading = false;
    this.loginError = error.error?.error || "An unexpected error occurred during login.";
    console.error("Login with code failed", error);
    return false;
  } finally {
      this.isLoginLoading = false;
  }
}
public async updateUserInfoAndProceed(updateInfo: { id: string, phone: string, email: string, authMode: string }) {
    this.loginError = ''; // Clear previous errors

    if (!this.cachedCredentials) {
      this.loginError = "Your session has expired. Please enter your username and password again.";
      throw new Error(this.loginError);
    }

    const { user, pw } = this.cachedCredentials;

    const payload = {
      user,
      pw,
      //location,
      updateInfo
    };

    try {
      const response: any = await this.http.post("/api/login/updateInfo", payload).toPromise();

      if (response?.state === 'require_2fa') {
        this.twoFactorRequired.next();
      } else {
        // Case when user is not 2fa required
        await this.followLogin(of(response), true, user);
      }
    } catch (err) {
      // The HTTP request itself failed
      this.loginError = err.error?.error || "An unexpected error occurred while updating your information.";
      throw err;
    }
  } 
}
